import { Badge, Dropdown } from "react-bootstrap";
import {
  formatRallyDateRange,
  formatRallyStatus,
} from "../../utils/rally.utils";

const statusVariant = {
  active: "success",
  upcoming: "info",
  completed: "secondary",
  cancelled: "danger",
};

const RalliesTable = ({ rallies, onView, onEdit }) => {
  return (
    <div className="table-responsive">
      <table className="table table-striped">
        <thead>
          <tr>
            <th>#</th>
            <th>Name</th>
            <th>Edition</th>
            <th>Location</th>
            <th>Dates</th>
            <th>Status</th>
            <th>Featured</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {rallies.map((rally, index) => {
            const rallyId = rally._id || rally.id;

            return (
              <tr key={rallyId || `${rally.name}-${index}`}>
                <td>{index + 1}</td>
                <td>{rally.name || "-"}</td>
                <td>{rally.edition_number ?? "-"}</td>
                <td>{rally.location || "-"}</td>
                <td>{formatRallyDateRange(rally.date, rally.end_date)}</td>
                <td>
                  <Badge bg={statusVariant[rally.status] || "secondary"}>
                    {formatRallyStatus(rally.status)}
                  </Badge>
                </td>
                <td>{rally.is_featured ? "Yes" : "No"}</td>
                <td className="text-center">
                  <Dropdown>
                    <Dropdown.Toggle
                      variant="link"
                      className="p-0 text-decoration-none"
                    >
                      &#x2022;&#x2022;&#x2022;
                    </Dropdown.Toggle>
                    <Dropdown.Menu align="end">
                      <Dropdown.Item
                        onClick={() => onView(rallyId)}
                        disabled={!rallyId}
                      >
                        View
                      </Dropdown.Item>
                      <Dropdown.Item
                        onClick={() => onEdit(rallyId)}
                        disabled={!rallyId}
                      >
                        Edit
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default RalliesTable;
